import axios from "axios";
import { MISSIONS, SITE_CONFIG, SYSTEM_STATUS } from "@/data/content";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export async function fetchConfig() {
  try {
    const res = await axios.get(`${API}/config`);
    return res.data;
  } catch {
    return SITE_CONFIG;
  }
}

export async function fetchStatus() {
  try {
    const res = await axios.get(`${API}/status`);
    return res.data;
  } catch {
    return SYSTEM_STATUS;
  }
}

export async function fetchMissions() {
  try {
    const res = await axios.get(`${API}/missions`);
    return Array.isArray(res.data) && res.data.length ? res.data : MISSIONS;
  } catch {
    return MISSIONS;
  }
}
